<template>
  <div class="g-bottom">
    <div class="g-bottom-content">
      <div class="content-l">
        <div class="content-img">
          <img style="width: 142px; height: auto" src="@assets/img/icmefEn.png" />
        </div>

        <div
          class="content-text bottom_3"
          style="
            cursor: pointer;
            display: flex;
            align-items: center;
            position: relative;
          "
        >
          <div style="display: flex; flex-direction: column">
            <div style="font-weight: 900; margin-bottom: 10px">Useful links</div>
            <div @click="goBooth">Book a stand</div>
            <div @click="goVisit" style="margin: 10px 0">Become a visitor</div>
            <div @click="goMeeting">Conference & Forum</div>
          </div>
        </div>
      </div>
      <div class="content-c">
        <p style="font-weight: bold">Official Platform</p>
        <div>
          <Poptip
            trigger="hover"
            placement="top"
            style="width: 30px; margin-right: 30px; position: relative"
          >
            <i
              style="margin: 0 40px 0 0; color: #06c140"
              class="icon iconfont icon-weixin2"
            ></i>
            <div slot="content">
              <img
                style="width: 116px; height: 116px; border-radius: 5px"
                src="@assets/img/cmef-wx.png"
              />
            </div>
          </Poptip>
          <Poptip
            trigger="hover"
            placement="top"
            style="width: 30px; margin-right: 30px; position: relative"
            popper-class="pop-ly"
          >
            <i style="color: #2475ca" class="icon iconfont icon-lingying"></i>
            <div slot="content">
              <img
                style="width: 106px; height: 105px; border-radius: 5px"
                src="@assets/img/cmef-ly.png"
              />
            </div>
          </Poptip>
          <Poptip
            trigger="hover"
            placement="top"
            style="width: 30px; position: relative"
            popper-class="pop-ly"
          >
            <i style="color: #06c140" class="icon iconfont icon-xiaochengxu"> </i>
            <div slot="content">
              <img
                style="width: 106px; height: 105px; border-radius: 5px"
                src="@assets/img/wx-weapp.png"
              />
            </div>
          </Poptip>
        </div>
      </div>
      <div class="logo">
        <img @click="lineTo1" src="./img/rse.png" />
        <img @click="lineTo2" src="./img/cmef.png" />
        <img @click="lineTo3" src="./img/recovery.png" />
        <img @click="lineTo4" src="./img/icmd.png" />
        <img @click="lineTo5" style="margin-right: 0" src="./img/wisdom.png" />
      </div>
    </div>
    <p class="copyright">
      Copyright &copy; {{ new Date().getFullYear() }} Reed Sinopharm Exhibitions Co. Ltd
      <a style="color: #024c8b" href="http://beian.miit.gov.cn/" target="_blank"
        >ICP：京ICP备06050757号-7</a
      >
      &nbsp;&nbsp;&nbsp;互联网药品信息服务资格证书 证书编号: (京)-经营 性-2020-0007
    </p>
  </div>
</template>

<script>
import config from "@assets/config.json";
export default {
  name: "g-bottom",
  methods: {
    lineTo1() {
      window.open("https://www.reed-sinopharm.com/", "_blank");
    },
    lineTo2() {
      window.open("https://www.cmef.com.cn/Demand/", "_blank");
    },
    lineTo3() {
      window.open("http://www.rehabshow.com.cn/", "_blank");
    },
    lineTo4() {
      window.open("http://www.icmd.com.cn", "_blank");
    },
    lineTo5() {
      window.open(`${config.PCUrl}/g1180.aspx`, "_blank");
    },
    goOnline() {
      //   window.open(`${config.PCUrl}/Portals/30/AttachUpload/pdf/20200601105322/iCMEF%E4%BE%9B%E9%9C%80%E5%AF%B9%E6%8E%A5%E5%90%88%E4%BD%9C%E6%96%B9%E6%A1%88.pdf`,'_blank');
      window.open(
        `https://oss.cmef.com.cn/cloudExhibition/files/202302/26ff40c408bd47178d651aa4537ef64d.pdf`,
        "_blank"
      );
    },
    goVisit() {
      window.open(
        "https://reg.reed-sinopharm.com/pc/#/login?id=c534464e36a54dd494454150b90dbaff&channelUuid=7836cfe827ad449aac826c8b05d1470d",
        "_blank"
      );
    },
    goMeeting() {
      window.open("https://www.cmef.com.cn/en/Information?cid=153&cid=163", "_blank");
    },
    goBooth() {
      window.open("https://i.cmef.com.cn/join-loginEn?t=1753072112854", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 799px) {
  .g-bottom {
    width: 100%;
    min-width: 1200px;
    height: 120px;
    background-color: #fff;
    border-top: 1px solid #175b94;
    &-content {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .content-l {
        width: 240px;
        height: 100%;
        // padding-top: 25px;
        font-size: 12px;
        font-weight: bold;
        div {
          display: flex;
          justify-content: space-between;
          color: #024c8b;
          span {
            cursor: pointer;
          }
        }
      }
      .content-c {
        width: 250px;
        height: 100%;
        margin-left: 100px;
        padding-top: 25px;
        color: #024c8b;
        font-size: 12px;
        div {
          margin-top: 10px;
          color: #49bd38;
          display: flex;
          i {
            font-size: 30px;
            margin-right: 30px;
          }
        }
      }
      .logo {
        margin-top: 55px;
        img {
          margin-right: 31px;
          cursor: pointer;
        }
      }
    }
    .copyright {
      width: 100%;
      line-height: 54px;
      text-align: center;
      color: #024c8b;
      font-size: 12px;
      font-weight: bold;
      background: #fff;
    }
  }
  .content-img {
    width: 142px;
    height: auto;
    margin-left: -31px;
  }
}
</style>
<style lang="scss">
@media (min-width: 799px) {
  .g-bottom {
    .ivu-poptip-popper {
      left: -45px !important;
      .ivu-poptip-inner {
        width: 120px;
        height: 120px;
      }
      .ivu-poptip-body {
        padding: 0 0 0 2px;
        div {
          margin-top: 5px;
        }
      }
      .ivu-poptip-arrow {
        margin-left: -22px;
      }
    }
    .pop-ly {
      .ivu-poptip-body {
        padding: 0 0 0 7px;
        div {
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.bottom_3 {
            width: 380px;
  bottom: 50px;
  flex-direction: column;
}
@media (max-width: 799px) {
  .bottom_3 {
     width: 100%;
    bottom: 0px;
    flex-direction: row;
  }
  .g-bottom {
    background-color: #f9f9f9;
    padding-top: calc(60vw / 7.5);
    padding-bottom: calc(40vw / 7.5);
    // position: fixed;
    // bottom: 0;
    // left: 0;
    width: 100%;
    .g-bottom-content {
      text-align: center;
      .content-l {
        width: 100%;
        text-align: center;
        .content-img {
          img {
            width: calc(140vw / 7.5);
          }
        }

        div {
          flex: 1;
          font-family: ArialMT;
          font-size: calc(26vw / 7.5);
          font-weight: normal;
          font-stretch: normal;
          line-height: calc(26vw / 7.5);
          letter-spacing: 0px;
          color: #1b1c80;
          span {
            margin: calc(40vw / 7.5) calc(40vw / 7.5) 0;
          }
        }
      }
      .content-c {
        .ivu-poptip {
          width: calc(64vw / 7.5) !important;
          // margin-right: calc(60vw/7.5)!important;
        }
        p {
          font-family: ArialMT;
          font-size: calc(36vw / 7.5);
          font-weight: normal;
          font-stretch: normal;
          line-height: calc(36vw / 7.5);
          letter-spacing: 0px;
          color: #1b1c80;
          margin: calc(54vw / 7.5) auto calc(40vw / 7.5);
        }
        .ivu-poptip-rel i {
          font-size: calc(64vw / 7.5);
        }
      }
      .logo {
        display: flex;
        justify-content: space-between;
        height: calc(120vw / 7.5);
        align-items: center;
        margin: calc(40vw / 7.5) auto;
        border-top: 1px solid #bfbfbf;
        border-bottom: 1px solid #bfbfbf;
        padding: 0 calc(35vw / 7.5);
        img {
          width: calc(120vw / 7.5);
        }
      }
    }
    .copyright {
      text-align: center;
      width: calc(520vw / 7.5);
      font-family: PingFang-SC-Medium;
      font-size: calc(20vw / 7.5);
      font-weight: normal;
      font-stretch: normal;
      line-height: calc(30vw / 7.5);
      letter-spacing: 0px;
      color: #8a8f8d;
      margin: 0 auto;
      a {
        color: #8a8f8d !important;
      }
    }
  }
}
</style>
